// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1wF1B","head":"Table_head__1DcLN","col":"Table_col__1_Blj"};